<template>
  <div class="user">
    <self-title :title="titles" :fixed="true" @titleClick="titleClick"></self-title>
    <transition name="slide-fade">
      <div class="main" v-permissions="'role:query'" v-show="web == 'main'">
        <div class="title">角色管理</div>
        <!-- <selfTitle/> -->
        <el-form class="search-form" ref="form" :inline="true" :model="searchForm" label-width="80px">
          <el-form-item>
            <el-button v-permissions="'role:add'" size="small" class="add" icon="el-icon-plus" @click="add"
              >新增角色</el-button
            >
          </el-form-item>
        </el-form>
        <el-table :data="tableData" height="78vh" style="width: 100%">
          <el-table-column label="角色名称">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注">
            <template slot-scope="scope">
              <span>{{ scope.row.remark }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                v-permissions="'role:update'"
                size="mini"
                type="primary"
                plain
                @click="handleEdit(scope.$index, scope.row, 'edit')"
                >编辑
              </el-button>
              <el-button
                v-permissions="'role:saveRoleMenu'"
                size="mini"
                type="warning"
                plain
                @click="handleEdit(scope.$index, scope.row, 'role')"
                >权限
              </el-button>
              <el-button
                v-permissions="'role:delete'"
                size="mini"
                plain
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页器 -->
        <!-- <div class="page">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
                         layout="total, prev, pager, next, sizes, jumper" :total="total">
          </el-pagination>
        </div> -->
      </div>
    </transition>
    <transition name="slide-fade">
      <div class="edit" v-show="web == 'edit' || web == 'add' || web == 'role'">
        <div class="title">{{ web == 'add' ? '新增角色' : '编辑角色' }}</div>
        <div class="el-form" label-position="top">
          <div v-if="web == 'edit' || web == 'add'">
            <el-form ref="addForm" :model="addForm" label-width="100px" :rules="web == 'add' ? rules : {}">
              <el-row>
                <el-col :xs="24" :sm="24">
                  <el-form-item label="名称" prop="userName">
                    <el-input v-model="addForm.name" placeholder="请输入"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24">
                  <el-form-item label="备注" prop="userPhone">
                    <el-input v-model="addForm.remark" placeholder="请输入"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item class="btn">
                <el-button v-show="!addForm.id" type="primary" size="small" class="save" @click="addSave('addForm')"
                  >保存
                </el-button>
                <el-button v-show="addForm.id" type="primary" size="small" class="save" @click="editSave('addForm')"
                  >保存
                </el-button>
                <el-button
                  v-show="addForm.id"
                  v-permissions="'role:saveRoleMenu'"
                  size="small"
                  type="warning"
                  plain
                  @click="handleEdit('add', addForm, 'role')"
                  >权限编辑
                </el-button>
                <el-button type="primary" size="small" plain class="cancel" @click="cancel">返回列表 </el-button>
              </el-form-item>
            </el-form>
          </div>
          <div v-if="web == 'role'">
            <el-form ref="midForm" :model="addForm" label-width="100px">
              <el-row>
                <el-col :xs="24" :sm="24">
                  <el-form-item label="权限" prop="midss">
                    <!-- <el-checkbox-group v-model="mids" @change="menusChange">
                      <el-checkbox v-for="(item, index) in menus" :label="item.id" :key="index"
                        >{{ item.title }}
                      </el-checkbox>
                    </el-checkbox-group> -->
                    <el-tree
                      :data="menuList"
                      show-checkbox
                      default-expand-all
                      node-key="id"
                      ref="tree"
                      highlight-current
                      :props="defaultProps"
                      :expand-on-click-node="false"
                      :check-on-click-node="true"
                    >
                    </el-tree>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item class="btn">
                <el-button v-show="addForm.id" type="primary" size="small" class="save" @click="saveRoleMenu"
                  >保存
                </el-button>
                <el-button
                  v-permissions="'role:update'"
                  size="small"
                  type="primary"
                  plain
                  @click="handleEdit('add', addForm, 'edit')"
                  >角色信息编辑
                </el-button>
                <el-button type="primary" size="small" plain class="cancel" @click="cancel">返回列表</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// import selfTitle from '../components/Title'
export default {
  name: 'User',
  // components: {
  //   selfTitle
  // },
  data() {
    return {
      userInfo: {},
      titles: ['角色管理'],
      web: 'main',
      searchForm: { name: '' },
      addForm: {
        name: '',
        remark: '',
        available: ''
      },
      mids: [], // 角色对应权限
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      menus: [],
      menuList: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      rules: {
        name: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入备注', trigger: 'blur' }]
      }
    }
  },
  methods: {
    titleClick(item, index) {
      console.log(item, index)
      if (item === '角色管理') {
        this.web = 'main'
        this.titles = ['角色管理'] // 导航菜单
      }
    },
    search() {
      // 查询
      this.queryAllRole()
    },
    reset() {
      // 重置
      this.form = {}
    },
    // 新增
    add() {
      this.web = 'add'
      this.mids = []
      this.titles = ['角色管理', '新增角色']
      setTimeout(() => {
        this.$refs.addForm.clearValidate()
      }, 0)
    },
    // 编辑
    handleEdit(index, row, web) {
      console.log(index, row)
      this.web = web
      this.titles = ['角色管理', '编辑角色']
      this.addForm = row
      this.mids = []
      this.queryMenuIdsByRid(this.addForm.id)
    },
    handleDelete(index, row) {
      // 删除
      console.log(index, row)
      this.$root.$children[0].vueConfirm(
        { message: '确认要删除此角色吗?' },
        () => {
          const param = {
            id: row.id
          }
          this.$get('/role/deleteById', param).then(
            result => {
              if (result.status === 200) {
                // localStorage.setItem('collectedPerson', JSON.stringify({ imgUrl: 'imageBase64' }))
                this.search()
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        },
        () => {
          return console.log('取消删除')
        }
      )
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.search()
    },
    addSave(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          const param = {
            name: this.addForm.name,
            remark: this.addForm.remark,
            available: this.addForm.available
          }
          this.$post('/role/saveRole', param).then(
            result => {
              if (result.status === 200) {
                // localStorage.setItem('collectedPerson', JSON.stringify({ imgUrl: 'imageBase64' }))
                // this.web = 'main'
                // this.titles = ['角色管理']
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
                // this.search()
                this.addForm = result.data
                this.handleEdit('add', result.data, 'edit')
              } else {
                this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 编辑角色提交
    editSave(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          const param = {
            id: this.addForm.id,
            name: this.addForm.name,
            remark: this.addForm.remark,
            available: this.addForm.available
          }
          this.$post('/role/updateRole', param).then(
            result => {
              if (result.status === 200) {
                // localStorage.setItem('collectedPerson', JSON.stringify({ imgUrl: 'imageBase64' }))
                // this.web = 'main'
                this.addForm = result.data
                // this.titles = ['角色管理']
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
                // this.search()
              } else {
                this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    cancel() {
      this.addForm = {
        qx: []
      }
      this.web = 'main'
      this.titles = ['角色管理']
      this.search()
    },
    queryAllRole() {
      // 查询用户列表
      const param = {
        page: 1,
        limit: 1000
      }
      this.$post('/role/queryAllRole', param).then(
        result => {
          if (result.status === 200) {
            this.total = result.count
            this.tableData = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
          }
        },
        error => {
          console.log('没调通', error)
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 查询权限菜单列表
    queryAllMenu() {
      const param = {}
      this.$get('/role/queryAllMenu', param).then(
        result => {
          if (result.status === 200) {
            this.menus = result.data
            const menus = [...result.data]
            for (let i = 0; i < menus.length; i++) {
              menus[i].label = menus[i].title
              if (menus[i].type === 'leftmenu') {
                menus[i].children = menus.filter(menu => {
                  return menu.pid === menus[i].id && menu.pid !== menu.id
                })
              }
            }
            this.menuList = menus.filter(menu => {
              return menu.type === 'leftmenu'
            })
            console.log(JSON.parse(JSON.stringify(this.menuList)))
          } else {
            this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 查询权限菜单列表
    queryMenuIdsByRid(id) {
      const param = {
        id: id
      }
      this.$get('/role/queryMenuIdsByRid', param).then(
        result => {
          if (result.status === 200) {
            this.mids = result.data
            const leftmenu = []
            this.menus.forEach((item, index) => {
              if (item.pid === item.id) {
                leftmenu.push(item.pid)
              }
            })
            this.mids2 = this.mids.filter(mid => {
              return leftmenu.indexOf(mid) < 0
            })
            console.log(leftmenu)
            console.log(this.mids2)
            this.$refs.tree.setCheckedKeys(this.mids2)
          } else {
            this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 查询权限菜单列表
    saveRoleMenu(id) {
      const halfMid = this.$refs.tree.getHalfCheckedKeys()
      const mid = this.$refs.tree.getCheckedKeys()
      const mid2 = [...halfMid, ...mid]
      const param = {
        rid: this.addForm.id,
        mids: mid2.sort()
      }
      this.$post('/role/saveRoleMenu', param).then(
        result => {
          if (result.status === 200) {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
          } else {
            this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    menusChange(val) {
      console.log(val)
    }
  },
  mounted() {
    this.queryAllRole()
    this.queryAllMenu()
  },
  beforeDestroy() {}
}
</script>

<style lang="less" scoped>
/deep/.el-tree-node {
  .el-tree-node {
    min-width: 180px;
    display: inline-block;
  }
}
/deep/.el-tree-node.is-expanded > .el-tree-node__children {
  display: flex;
  flex-wrap: wrap;
}
</style>
